import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Formik, FormikHelpers } from "formik";
import { useUpdateEmail } from "../../../../hooks/licenses/useUpdateEmail";
import {
  ControlcenterMelcoModelsBridgeSerialNumber,
  useFormSubmit,
} from "melco-shared-logic";
//import { useQueryClient } from "react-query";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { DisplayEditEmailForm } from "../../form/DisplayEditEmailForm";

type EditEmailDrawerProps = {
  email_address: string;
  drawerRef: any;
  serial_number: string;
  onCloseDrawerCallback?: () => void;
};

export const EditEmailDrawer: React.FC<EditEmailDrawerProps> = ({
  email_address,
  serial_number,
  drawerRef,
  onCloseDrawerCallback,
}) => {
  const { t } = useTranslation();
  // const queryClient = useQueryClient();
  // const queryKey = "editemail";
  const updateLicense = useUpdateEmail();

  const { isDrawerOpen, closeDrawer } = drawerRef;
  const initialValues: ControlcenterMelcoModelsBridgeSerialNumber = {
    new_email_address: email_address,
    serial_number: serial_number,
  };

  const onSubmit = async (
    values: ControlcenterMelcoModelsBridgeSerialNumber,
    formikHelpers: FormikHelpers<ControlcenterMelcoModelsBridgeSerialNumber>
  ) => {
    await onUpdateLicense(values, formikHelpers, {});
  };

  const formSubmitToUpdateLicense = () => {
    return [
      async (
        values: ControlcenterMelcoModelsBridgeSerialNumber,
        formikHelpers: FormikHelpers<ControlcenterMelcoModelsBridgeSerialNumber>
      ) => {
        return handleUpdateProfile(values, formikHelpers, {});
      },
      {
        translationPrefix: "",
        onError: () => {
          // refetch entity from server
          // queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const handleUpdateProfile = async (
    values: ControlcenterMelcoModelsBridgeSerialNumber,
    formikHelpers: FormikHelpers<ControlcenterMelcoModelsBridgeSerialNumber>,
    options: {}
  ) => {
    await updateLicense(
      values?.new_email_address ?? "",
      values?.serial_number ?? ""
    );

    closeDrawer();

    if (onCloseDrawerCallback) onCloseDrawerCallback();
  };

  const onUpdateLicense = useFormSubmit(...formSubmitToUpdateLicense());

  return (
    <Drawer
      title={t("licenses.basic.detail.editemail.title")}
      placement="right"
      width={700}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 10 }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        // validationSchema={{}}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayEditEmailForm />
        </DirtyFormPrompt>
      </Formik>
    </Drawer>
  );
};
